import * as React from 'react';
import { Button, Col, Row } from 'reactstrap';

interface IHomeWhyProps {
  toggleCreateConsultantModal: () => void;
  toggleCreateProjectModal: () => void;
}

export const HomeWhy: React.SFC<IHomeWhyProps> = ({
  toggleCreateConsultantModal,
  toggleCreateProjectModal,
}) => (
  <section  className='bg-white p-4'>
    <Row>
    <Col md='1' xs='0'/>
      <Col md='5' xs='12' className='text-md-right text-sm-center p-4 my-auto'>

        <h2 style={{ fontSize: '48px' }}>
          Pourquoi choisir  
          <br />
          <strong className='text-warning'>BeAdvize ?</strong>
        </h2>

      </Col>
      <svg className='d-none d-md-block' width='1px'  > 
          <line x1="0" x2="0" y1="0" y2="500" stroke-linecap="square" stroke="#1b5ea6" stroke-width="2px"  />
      </svg>
      <Col md='5' xs='12' className='text-left p-4' >
        <span className='text-primary' style={{ fontSize: '18px' }}>
        <strong>Le projet facilement </strong>
          <br className ='d-none d-md-block'/>
          <strong>avec un accompagnement sur mesure</strong>
        </span>
        <p className='mt-3 mr-sm-6' >
          PME ou grand groupe, vos besoins sont différents et uniques.
          <br />
          <strong className='text-warning'>Notre modèle agile</strong> peut
          s'adapter à vos enjeux et contraintes :
          <br />
          <br />&#9656; en <strong className='text-warning'>
            sélectionnant
          </strong>{' '}
          parmi notre{' '}
          <strong className='text-warning'>communauté de consultants</strong> le
          ou les talents avec le savoir-faire que vous recherchez
          <br />
          <br />&#9656; vous <strong className='text-warning'>
            accompagnant
          </strong>{' '}
          aussi bien lors de la construction de votre projet que pendant sa mise
          en place
        </p>
      </Col>
      <Col md='1' xs='0' />
    </Row>
    <Row>
      <Col md='1' xs='0' />
      <Col md='5' xs='12' className='text-md-right text-sm-left p-4   border-top border-primary'>
        <span className='text-primary' style={{ fontSize: '18px' }}>
        <strong>La transparence du modèle {' '}</strong>
          <br className ='d-none d-md-block'/>
          <strong>BeAdvize</strong>
        </span>
        <p className='mt-3 ml-md-6'   >
          Le modèle de notre plateforme repose sur une{' '}
          <strong className='text-warning'>transparence totale</strong> de la
          tarification :<br />
          <br />&#9656; les{' '}
          <strong className='text-warning'>consultants proposent</strong>{' '}
          eux-mêmes{' '}
          <strong className='text-warning'>
            le tarif journalier ou le budget global
          </strong>
          , et BeAdvize facturera un pourcentage pour le traitement de l'appel
          d'offre, la mise en relation et le suivi.
          <br />
          <br />&#9656; ce pourcentage est bien sur{' '}
          <strong className='text-warning'>dégressif</strong> en fonction de la
          durée de la mission.
        </p>
      </Col>
      <svg  className='d-none d-md-block' width='1px'  > 
          <line x1="0" x2="0" y1="0" y2="500" stroke-linecap="square" stroke="#1b5ea6" stroke-width="2px"  />
      </svg>
      <Col md='5' xs='12' className='text-left p-4 border-top border-primary'>
        <span className='text-primary' style={{ fontSize: '18px' }}>
        <strong>Une communauté de consultants</strong>
          <br />
          <strong>et experts indépendants de haut niveau</strong>
        </span>
        <p className='mt-3 mr-sm-6' >
          Les indépendants sur BeAdvize sont{' '}
          <strong className='text-warning'>sélectionnés et évalués</strong> pour
          leurs {' '}
          <strong className='text-warning'>
            expertises et qualités humaines
          </strong>
          .
          <br />
          Le processus de référecemment sur la plateforme permet :<br />
          <br />&#9656; de <strong className='text-warning'>jauger</strong> les
          qualités professionnelles et humaines, conditions sinequanone pour
          répondre aux enjeux des clients
          <br />
          <br />&#9656; de <strong className='text-warning'>cibler</strong> finement
          la recherche en terme de type de missions
        </p>
      </Col>
      <Col md='1' xs='0' />
    </Row>
    <Row>
      <Col md='3' xs='0' />
        <Col md='6' xs='12' className='d-flex flex-column align-items-center border border-primary p-4'>
          <span className='text-primary' style={{ fontSize: '18px' }}>
            Commencez dès maintenant :
          </span>
          <Row className='w-100 pt-3'>
            <Col md='6' xs='12' className=''>
              <Button className='text-white text-uppercase bg-success w-100 border-0' onClick={toggleCreateProjectModal}>
                Déposez votre projet
              </Button>
            </Col>
            <Col md='6' xs='12' className='pt-2 pt-md-0'>
              <Button className='text-white text-uppercase bg-secondary w-100 border-0' onClick={toggleCreateConsultantModal}>
                Proposez vos services
              </Button>
            </Col>
          </Row>
        </Col>
      <Col md='3' xs='0' />
    </Row>
  </section>
);



// WEBPACK FOOTER //
// ./src/components/HomePage/HomeWhy.tsx